/**
 * Created by Claude on 13.02.2026
 */

const IslandDecorationStartWindow = Prefab.createWindow(
    "island_decoration_start_window",
    "island_decoration_start_window_prefab_json",
    {
        bundles: (mission) => [`island_decoration_illustrations_${mission.logic.period}`]
    }
);

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    ISLAND_DECORATION_START_COLOR: new cc.Color(198, 110, 78, 255),
    ISLAND_DECORATION_LABEL_COLOR: new cc.Color(252, 22, 157, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ISLAND_DECORATION_START_TEXT: {
        size: 40,
        name: "nostroke",
        color: cleverapps.styles.COLORS.ISLAND_DECORATION_START_COLOR
    },

    ISLAND_DECORATION_START_LABEL: {
        size: 50,
        name: "nostroke",
        color: cleverapps.styles.COLORS.ISLAND_DECORATION_LABEL_COLOR
    }
});
